<div class="container">
    <div class="row header py-2">
        <div class="col cursor text-center">
            <h6>Olar Points</h6>
        </div>
    </div>
</div>
<div style="padding-top: 40px !important;">
    <div class="row form-group">
        <div class="col">
            <div class="row">
                <div class="col table-responsive">
                    <table class="table">
                        <thead class="thead-light">
                            <tr>
                                <th>Order/Date</th>
                                <th class="text-right">Earned</th>
                                <th class="text-right">Redeemed</th>
                                <th class="text-right">Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="OlarPointsHistory.length === 0" class="border-bottom">
                                <td colspan="4">No Olar history found</td>
                            </tr>
                            <tr *ngFor="let rowdata of OlarPointsHistory">
                                <td>
                                    <a *ngIf="rowdata.ooco_sales_order_id" href="javascript:void(0)"
                                        (click)="onActionClick('VIEW_RECEIPT',receipt, rowdata.oocpl_oodcdr_guid, rowdata.ooco_company_id)">{{rowdata.ooco_sales_order_id}}</a>
                                    <br *ngIf="rowdata.ooco_sales_order_id" />
                                    {{rowdata.oocpl_created_at | date: 'dd/MM/yyyy'}}
                                </td>
                                <td class="text-right">{{rowdata.oocpl_points_earned === 0 ? '' :
                                    rowdata.oocpl_points_earned}}</td>
                                <td class="text-right">{{rowdata.oocpl_points_redeemed === 0 ? '' :
                                    rowdata.oocpl_points_redeemed }}</td>
                                <td class="text-right">{{rowdata.oocpl_total_points}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<app-ecom-footer class="footer"></app-ecom-footer>
<app-loading-component></app-loading-component>

<ng-template #receipt>
    <div class="modal-header">
        <h6 class="modal-title pull-left">
            Invoice
        </h6>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body pt-0">
        <div class="row border-bottom">
            <div class="col-2 text-center">
                <img *ngIf="LogoPath" width="50px" height="50px" [src]="LogoPath" alt="Logo">
            </div>
            <div class="col">
                <div class="">
                    <span class="font-weight-bold-500 h5 m-2 mt-3">{{userSelectedStore.serviceCompanyName}}</span>
                </div>
                <div>
                    Business No - {{CompanyBusinessNumber}}
                </div>
                <div>
                    {{userSelectedStore.serviceLocationAddress}}
                </div>
            </div>
        </div>
        <div class="row pt-2">
            <div class="col"><span class="font-weight-bold-500">Tax Invoice :</span> {{invoiceNumber}}</div>
            <div class="col text-right">
                <span class="font-weight-bold-500">Order no :</span>
                {{userSelectedStore.storeCart.orderId}}
            </div>
        </div>
        <div class="row border-bottom pb-2">
            <div class="col"><span class="font-weight-bold-500">Customer :</span> {{userServiceBase.userName}}</div>
            <div class="col text-right"><span class="font-weight-bold-500">Date :</span> {{orderDatetime}}</div>
        </div>
        <div class="row no-gutters py-2">
            <div class="col-7">
                <div>
                    <span class="fw-500 font-weight-bold">Item</span>
                </div>
            </div>
            <div class="col-2">
                <span class="fw-500 font-weight-bold">Qty</span>
            </div>
            <div class="col-3 text-right">
                <span class="fw-500 font-weight-bold">Price</span>
            </div>
        </div>
        <div class="pt-3 pb-3  border-top">
            <div class="row no-gutters py-1" *ngFor="let item of userSelectedStore.storeCart.orderItems;let i=index;">
                <div class="col-7">
                    <div class="text-truncate font-weight-bold-500 h6 mb-0">
                        {{item.itemName}}
                    </div>
                    <p class="text-muted text-break font-color-light-grey mb-0" style="font-size: 12px;">
                        {{item.variantList[0].variantName}}
                    </p>
                    <p class="text-muted text-break font-color-light-grey mb-0 fa-xs-small-70"
                        *ngFor="let modifierset of item.modifierSetList">
                        <small>{{modifierset.modifierName}} - </small>
                        <span *ngFor="let modifier of modifierset.modifierOptions;let optionindex=index;">
                            {{modifier.optionName}} <span
                                *ngIf="optionindex !== modifierset.modifierOptions.length - 1">,</span>
                        </span>
                    </p>
                </div>
                <div class="col-2">
                    <span>{{item.quantity}}</span>
                </div>
                <div class="col-3 text-right">
                    <span>{{item.totalPrice.toFixed(2)}}</span>
                </div>
            </div>
        </div>

        <div class="row no-gutters border-top py-2">
            <div class="col text-right">
                <label for="" class="fw-500 mb-0 font-weight-bold-500">Sub Total</label>
            </div>
            <div class="col-3 text-right">
                <label class="mb-0">
                    <span>
                        <small *ngIf="position === 'BACK'">
                            {{currency}}
                        </small>
                        {{userSelectedStore.storeCart.orderSubTotal.toFixed(2)}}
                        <small *ngIf="position === 'FRONT'">
                            {{currency}}
                        </small>
                    </span>
                </label>
            </div>
        </div>

        <div class="row no-gutters border-top py-2">
            <div class="col text-right">
              <label for="" class="fw-500 mb-0 font-weight-bold-500">Order Discount</label>
            </div>
            <div class="col-3 text-right">
              <label class="mb-0">
                <span>
                  <small *ngIf="position === 'BACK'">
                    {{currency}}
                  </small>
                  {{userSelectedStore.storeCart.orderDiscountTotal.toFixed(2)}}
                  <small *ngIf="position === 'FRONT'">
                    {{currency}}
                  </small>
                </span>
              </label>
            </div>
          </div>

        <div class="row" *ngIf="discountsApplied">
            <div class="col">
                <div *ngFor="let discount of discountsApplied">
                    <div class="row no-gutters border-top py-2" *ngIf="discount.ooocd_type === 'REFERRAL_DISCOUNT'">
                        <div class="col text-right">
                            <label for="" class="fw-500 mb-0 font-weight-bold-500">
                                {{discount.ooocd_mod_name}}
                                <span *ngIf="discount.ooocd_percentage > 0">
                                    ({{discount.ooocd_percentage}}%)
                                </span>
                            </label>
                        </div>
                        <div class="col-3 text-right">
                            <label class="mb-0">
                                <span>
                                    <small *ngIf="position === 'BACK'">
                                        {{currency}}
                                    </small>
                                    -{{discount.ooocd_amount.toFixed(2)}}
                                    <small *ngIf="position === 'FRONT'">
                                        {{currency}}
                                    </small>
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </div> 
        </div>

        <div class="row no-gutters border-top py-2" *ngFor="let tax of taxList">
            <div class="col text-right">
                <label for="" class="fw-500 mb-0 font-weight-bold-500">{{tax.TaxName}}</label>
            </div>
            <div class="col-3 text-right">
                <label class="mb-0">
                    <span>
                        <small *ngIf="position === 'BACK'">
                            {{currency}}
                        </small>
                        {{tax.TaxAmount.toFixed(2)}}
                        <small *ngIf="position === 'FRONT'">
                            {{currency}}
                        </small>
                    </span>
                </label>
            </div>
        </div>
        
        <div class="row no-gutters border-top py-2" *ngIf="serviceType === 'DELIVERY'">
            <div class="col text-right">
              <label for="" class="fw-500 mb-0 font-weight-bold-500">Delivery Charges</label>
            </div>
            <div class="col-3 text-right">
              <label class="mb-0">
                <span>
                  <small *ngIf="position === 'BACK'">
                    {{currency}}
                  </small>
                  {{userSelectedStore.storeCart.orderDeliveryCharge.toFixed(2)}}
                  <small *ngIf="position === 'FRONT'">
                    {{currency}}
                  </small>
                </span>
              </label>
            </div>
          </div>

        <div class="row no-gutters border-top py-2" *ngIf="serviceType === 'DINE_IN'">
            <div class="col text-right">
              <label for="" class="fw-500 mb-0 font-weight-bold-500">
                Service Charges <span *ngIf="surcharges">({{surcharges.sosur_surcharge_percentage}}%)</span>
              </label>
            </div>
            <div class="col-3 text-right">
              <label class="mb-0">
                <span>
                  <small *ngIf="position === 'BACK'">
                    {{currency}}
                  </small>
                  {{userSelectedStore.storeCart.orderServiceCharge.toFixed(2)}}
                  <small *ngIf="position === 'FRONT'">
                    {{currency}}
                  </small>
                </span>
              </label>
            </div>
          </div>

        <div class="row" *ngIf="discountsApplied">
            <div class="col">
                <div *ngFor="let discount of discountsApplied">
                    <div class="row no-gutters border-top py-2" *ngIf="discount.ooocd_type !== 'REFERRAL_DISCOUNT'">
                        <div class="col text-right">
                            <label for="" class="fw-500 mb-0 font-weight-bold-500">
                                {{discount.ooocd_mod_name}}
                                <span *ngIf="discount.ooocd_percentage > 0">
                                    ({{discount.ooocd_percentage}}%)
                                </span>
                            </label>
                        </div>
                        <div class="col-3 text-right">
                            <label class="mb-0">
                                <span>
                                    <small *ngIf="position === 'BACK'">
                                        {{currency}}
                                    </small>
                                    -{{discount.ooocd_amount.toFixed(2)}}
                                    <small *ngIf="position === 'FRONT'">
                                        {{currency}}
                                    </small>
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row no-gutters border-top py-2">
            <div class="col text-right">
                <label for="" class="fw-500 mb-0 font-weight-bold-500">Total</label>
            </div>
            <div class="col-3 text-right">
                <label for="" class="font-weight-bold mb-0">
                    <span>
                        <small *ngIf="position === 'BACK'">
                            {{currency}}
                        </small>
                        {{userSelectedStore.storeCart.orderTotal.toFixed(2)}}
                        <small *ngIf="position === 'FRONT'">
                            {{currency}}
                        </small>
                    </span>
                </label>
            </div>
        </div>

        <div class="row no-gutters border-top py-2">
            <div class="col text-right">
                <label for="" class="fw-500 mb-0 font-weight-bold-500">Paid by {{paymentMethod}}</label>
            </div>
            <div class="col-3 text-right">
                <label for="" class="font-weight-bold mb-0">
                    <span>
                        <small *ngIf="position === 'BACK'">
                            {{currency}}
                        </small>
                        {{userSelectedStore.storeCart.orderTotal.toFixed(2)}}
                        <small *ngIf="position === 'FRONT'">
                            {{currency}}
                        </small>
                    </span>
                </label>
            </div>
        </div>

        <br />
        <div class="row form-group email-div">
            <div class="col-6 input-group input-group-lg pr-0" [formGroup]="emailForm">
                <input type="email" class="form-control " placeholder="youremail@mail.com" formControlName="email"
                    [ngClass]="{'has-error': ((emailForm.get('email').touched || emailForm.get('email').dirty) &&  emailForm.get('email').errors)}" />
            </div>
            <div class="col text-right pr-0 pl-0">
                <button
                    class="btn cart-btn-paylater font-weight-bold-500 box-shadow-none btn-block rounded btn-sm button-border-radius"
                    (click)="onSendEmailClick(orderDetails.companyId,orderDetails.oodcdr_guid,orderDetails.oodcdr_type)">
                    Send
                </button>
            </div>
            <div class="col text-center">
                <button class="btn cart-btn-paylater font-weight-bold-500 box-shadow-none btn-block rounded btn-sm"
                    (click)="onDownloadPdfClick(orderDetails.companyId,orderDetails.oodcdr_guid,orderDetails.oodcdr_type)">
                    Download
                    <!--<i class="far fa-file-pdf fa-lg cursor"></i>-->
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <span [ngClass]="{'text-success': invoiceRequest, 'text-danger': !invoiceRequest}">{{invoiceMsg}}</span>
            </div>
        </div>
    </div>
</ng-template>